import { lightTheme } from '../../../styles/theme';
import { formatLanguageName } from '../helpers/chatFormat';
import { MessageTranslationState } from '../hooks/useMessageTranslations';
import { MessageMeta, SenderName } from './MessageBubble.styled';

/**
 * The line under a message that is, or is becoming, a translation: what
 * language it came from and the way back, or why it could not be done.
 *
 * Nothing once the reader has gone back to the original - the Translate
 * button in the actions brings the translation back from memory, and a line
 * saying "this is the original" under every such message would be noise.
 */
export const MessageTranslationNote = ({
  translation,
  own,
  onToggle,
}: {
  translation: MessageTranslationState | null;
  own: boolean;
  onToggle: () => void;
}) => {
  if (!translation || translation.status === 'original') return null;

  if (translation.status === 'loading') {
    return (
      <MessageMeta $own={own} aria-live="polite">
        Translating...
      </MessageMeta>
    );
  }

  if (translation.status === 'failed') {
    return (
      <MessageMeta $own={own} role="alert">
        <span style={{ color: lightTheme.primary }}>
          {translation.error}
          {translation.retryable && (
            <>
              {' '}
              <SenderName $clickable onClick={onToggle}>
                Try again
              </SenderName>
            </>
          )}
        </span>
      </MessageMeta>
    );
  }

  return (
    <MessageMeta $own={own}>
      <span>
        Translated from {formatLanguageName(translation.sourceLanguage)} ·{' '}
        <SenderName $clickable onClick={onToggle}>
          See original
        </SenderName>
      </span>
    </MessageMeta>
  );
};
